import { THEME_FIELD_STRUCTURE } from '@/dashboard/scenes/PageEdit/scenes/PageDesign/theming/themeFieldRegistry';
import { ThemeFieldBuilder } from './themeFieldBuilder';

// Section IDs that belong to the "Theme" group (between Layout and Elements).
// Shared with getDesignSections.js — keep in sync.
export const THEME_GROUP_IDS = new Set(['global', 'columns', 'cards']);

export const getDesignFormFields = (
  { themeValues, setFieldValue, values, seller, group, page, product, previewColorMode } = {
    themeValues: {},
    setFieldValue: () => {},
    values: {},
    seller: null,
    group: undefined,
    page: null,
    product: null,
    previewColorMode: null,
  },
) => {
  const fieldBuilder = new ThemeFieldBuilder(
    themeValues,
    setFieldValue,
    values,
    seller,
    page,
    product,
    previewColorMode,
  );

  let entries = Object.entries(THEME_FIELD_STRUCTURE);

  if (group === 'theme') {
    entries = entries.filter(([, fieldStructure]) => THEME_GROUP_IDS.has(fieldStructure.id));
  } else if (group === 'elements') {
    entries = entries.filter(([, fieldStructure]) => !THEME_GROUP_IDS.has(fieldStructure.id));
  }

  return entries
    .map(([key, fieldStructure]) => fieldBuilder.buildFormSection(key, fieldStructure))
    .filter(Boolean);
};
